import { Alert, Box, Button, Group, Text } from "@mantine/core";
import { IProjectDeprecated } from "@mctypes/global.types";
import { IMCBIMAPI } from "@mctypes/mcbim.types";
import { IconCheck, IconDeviceFloppy } from "@tabler/icons-react";
import React from "react";
import { Prompt } from "react-router-dom";
import { FailedAlert, MCLoader } from "../../../../../components";
import { useAppSelector } from "../../../../../hooks";
import { useUpdateMcBimIfcFilesMutation } from "../McBimRTK";
import { selectedFilesAndFilesSavedInMcBimIsEqual } from "../mcBimSlice";
import McBimBim360FileHandler from "./McBimBim360FileHandler";

const McBimFilePage: React.FC<{ mcbimProject: IMCBIMAPI.Project; project: IProjectDeprecated }> = ({
  mcbimProject,
  project,
}) => {
  const selectedFiles = useAppSelector((state) => state.mcBimReducer.selectedIfcFiles);

  const [updateFiles, { isLoading: updateFilesLoading, error: updateFilesError }] = useUpdateMcBimIfcFilesMutation();

  const filesAreEqual = selectedFilesAndFilesSavedInMcBimIsEqual(selectedFiles, mcbimProject.ifcFiles);
  const hasUnsavedChanges = filesAreEqual === false;
  const unsavedChangesMessage = "Du har endringer som ikke er lagret til MCBIM. Vil du virkelig forlate siden?";

  React.useEffect(() => {
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = unsavedChangesMessage;
        return unsavedChangesMessage;
      }
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  const onLocationChange = () => {
    return unsavedChangesMessage;
  };

  const _updateFiles = () => {
    const _files = selectedFiles.map((file) => {
      return {
        fileStorageId: file.fileStorageId,
        fileName: file.fileName,
        filePath: file.filePath,
      };
    });
    updateFiles({ projectId: project._id, ifcFiles: _files });
  };

  return (
    <Box p="xs" h="100%" style={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
      {updateFilesLoading && <MCLoader loading />}
      {updateFilesError && <FailedAlert />}
      <Prompt when={hasUnsavedChanges} message={onLocationChange} />
      {selectedFiles?.length === 0 && mcbimProject.ifcFiles?.length === 0 && (
        <Alert color="blue">Ingen filer er lagret for innlasting i MCBIM ennå. Klikk nedenfor for å legge til</Alert>
      )}
      <Box w="100%" style={{ flex: 1, minHeight: 0 }}>
        <McBimBim360FileHandler
          mcBimProject={mcbimProject}
          actions={
            <>
              {filesAreEqual === false && (
                <Button color="green" leftSection={<IconDeviceFloppy size={16} />} onClick={_updateFiles}>
                  Lagre til MCBIM
                </Button>
              )}
              {mcbimProject.ifcFiles?.length > 0 && (
                <Group gap={6} c="green.7">
                  <IconCheck size={18} />
                  <Text fw={600}>{mcbimProject.ifcFiles?.length} filer lagret for lasting i MCBIM</Text>
                </Group>
              )}
            </>
          }
        />
      </Box>
    </Box>
  );
};

export default McBimFilePage;
